<template>
  <div class="analyze-container"
       v-loading.fullscreen="fullscreenLoading">
    <div class="title">
      视频解析工具
    </div>
    <div class="intro-code-box">
      <div class="intro">
        TK后勤部目前专注于TikTok服务商领域，主要服务对象为TikTok从业人员，力求以真诚靠谱的服务与产品来满足大家运营过程中的相关需求。
        <br />目前主要提供以下三块服务：<br />
        <strong>
          · 硬件类（如二手工作机／办公电脑/全球海外运营商废卡/运营商专线/软路由等）<br />
          · 软件类（如账号云控／无人直播系统/店群ERP/达人邀约软件等）<br />
          · 资源信息类（小店售卖和代开／小店补单/刷粉刷赞/官方机构代开/店铺报白/金币充值等）<br />
        </strong><br />
        业务对接可联系右边二维码👉🏻
      </div>
      <div class="code">
        <img src="../../assets/down-code.png"
             alt="">
      </div>
    </div>
    <div class="tab-box">
      <el-tabs v-model="activeName"
               @tab-click="handleClick">
        <el-tab-pane label="全网单个视频/图集获取"
                     name="1">
          本页面为单个链接提取页面，支持提取视频/图集，<br />
          支持几百个平台的链接提取，复制作品分享页面链接即可提取。
        </el-tab-pane>
        <el-tab-pane label="作者主页批量提取"
                     name="2">
          本页面为批量提取页面，支持TikTok(作者主页、Hashtag列表)、Instagram(作者主页、Hashtag列表)、YouTube(频道页、播放列表)、抖音(主页、合集)、小红薯、西瓜视频、美拍、火山、微博、绿洲、Bilibili、轻视频、AcFun、好看、UC浏览器视频、**等视频批量提取，复制作者主页分享链接即可获取作者所有的作品并提取出来<br />
          网页版仅支持一键批量提取，批量提取后需要自己选择视频然后手动下载。</el-tab-pane>
      </el-tabs>
    </div>
    <div class="use-method">
      <div class="use-method-title">
        使用方法:
      </div>
      <div class="use-method-content">
        · 打开APP，点开某个视频/图集，点击分享按钮，在分享弹框中点击复制链接或通过分享到微信QQ等获取分享链接
        <br />· 将刚才复制的链接粘贴到下面的输入框
        <br />· 将提取后的视频链接放入下载工具（如: <a href="https://www.xunlei.com/" target="blank">迅雷</a> 、<a href="https://www.freedownloadmanager.org/blog/" target="blank">FDM</a> ）即可开始下载
      </div>
    </div>
    <div class="input-box">
      <input type="text"
             v-model="url"
             placeholder="请将作者主页分享链接粘贴到这里">
      <div @click="getVideo"
           class="btn">
        提取
      </div>
    </div>

    <div class="mul-video-box">
      <div class="mul-video-box-top" v-if="mulList.length != 0">
        <div class="choose-all"
             @click="chooseAllUrl">
          <img v-if="!chooseAll"
               src="../../assets/unchoose.png"
               alt="">
          <img v-else
               src="../../assets/ischoose.png"
               alt="">
          全选
        </div>
        <div @click="copyChooseUrl"
             class="download">
          <img src="../../assets/copy.png"
               alt="">
          复制已选中的视频链接
        </div>
      </div>
      <div class="mul-video-box-bot">
        <div class="mul-video-box-bot-item"
             v-for="item in mulList"
             :key="item.id">
          <div class="media-content"
               v-for="media in item.medias"
               :key="media.resource_url">
            <div class="media-content-top">
              <img class="cover"
                   :src="media.preview_url ? media.preview_url : media.resource_url"
                   alt="">
              <img @click="chooseUrl(media.resource_url)"
                   v-if="chooseList.findIndex(item => item == media.resource_url) == -1"
                   class="choose"
                   src="../../assets/unchoose.png"
                   alt="">
              <img @click="chooseUrl(media.resource_url)"
                   v-else
                   class="choose"
                   src="../../assets/ischoose.png"
                   alt="">
            </div>
            <div class="media-content-bot">
              <div class="post-name">
                {{ item.text }}
              </div>
              <div class="btn-box">
                <a class="download"
                   target="downloadFile"
                   :href="media.resource_url">
                  下载
                </a>
                <div class="download"
                     @click="copyUrl(media.resource_url)">
                  复制链接
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="view-more"
           @click="getVideo"
           v-if="hasMore">
        查看更多
      </div>
    </div>

    <div class="question-box">
      <div class="question-box-title">
        <span>?</span>
        <div class="question-title">
          常见疑问
        </div>
        <div class="line"></div>
      </div>
      <div class="question-box-item">
        <div class="question-box-item-top">
          Q1：电脑上部分浏览器点下载视频按钮后，跳转到视频页面，如何下载到本地呢？
        </div>
        <div class="question-box-item-bot">
          A1：电脑上少数浏览器不支持直接下载，但可以在下载视频按钮上点击右键，然后选择"目标另存为"或"链接存储为"来下载视频；或者到跳转后的视频页面，在视频画面上点击右键，然后选择"视频另存为"来下载视频。推荐使用谷歌Chrome浏览器、360浏览器、QQ浏览器等主流浏览器。
        </div>
      </div>
      <div class="question-box-item">
        <div class="question-box-item-top">
          Q2：iOS设备（iPhone、iPad）上点击下载视频按钮后，跳转到视频页面，并没有直接下载，怎么办？
        </div>
        <div class="question-box-item-bot">
          A2：我们可以用到iOS系统手机自带Safari浏览器点击解析视频后，长按视频下载按钮会弹出一个列表，然后点击下载文件链接，右上角然后把刚下载的视频储存视频到手机相册即可，也可以借助第三方App来完成下载，iOS用户在App Store下载免费的Documents ，然后在Documents右下角按钮的内置浏览器中使用本站，可以完美下载视频。
        </div>
      </div>
      <div class="question-box-item">
        <div class="question-box-item-top">
          Q3：Android手机上可以用吗？
        </div>
        <div class="question-box-item-bot">
          A1：电脑上少数浏览器不支持直接下载，但可以在下载视频按钮上点击右键，然后选择"目标另存为"或"链接存储为"来下载视频；或者到跳转后的视频页面，在视频画面上点击右键，然后选择"视频另存为"来下载视频。推荐使用谷歌Chrome浏览器、360浏览器、QQ浏览器等主流浏览器。
        </div>
      </div>
      <div class="question-box-item">
        <div class="question-box-item-top">
          Q4：下载后的视频打不开怎么办？
        </div>
        <div class="question-box-item-bot">
          A4：一般是文件后缀问题，把下载后的文件后缀名改为.mp4即可播放。
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { videoAnalyze } from "@/api/home"
import { Message } from 'element-ui'

export default {
  data () {
    return {
      activeName: '1',
      url: '',
      singleVideo: {},
      mulList: [],
      nextCursor: '',
      hasMore: false,
      chooseList: [],
      chooseAll: false,
      fullscreenLoading: false
    }
  },
  created () {
  },
  methods: {
    handleClick (e) {
      this.chooseList = []
      this.mulList = []
      this.hasMore = false
    },
    chooseAllUrl () {
      if (this.chooseAll) {
        this.mulList.forEach(item => {
          item.medias.forEach(media => {
            media.isChoose = false
          })
        })
        this.chooseList = []
        this.chooseAll = false
      } else {
        this.chooseList = []
        this.mulList.forEach(item => {
          item.medias.forEach(media => {
            media.isChoose = true
            this.chooseList.push(media.resource_url)
          })
        })
        this.chooseAll = true
      }
    },
    copyChooseUrl () {
      let url = ``
      this.chooseList.forEach(item => {
        url += item + `
        `
      })
      this.copyMoreUrl(url)
    },
    copyMoreUrl (url) {
      let input = document.createElement("textarea"); // 创建input对象
      input.value = url; // 设置复制内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.$message.success("成功复制链接");
    },
    copyUrl (url) {
      let input = document.createElement("input"); // 创建input对象
      input.value = url; // 设置复制内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.$message.success("成功复制链接");
    },
    downloadVideo (url) {
      window.open(url)
    },
    async getVideo () {
      let data = {
        type: this.activeName,
        url: this.url
      }
      if (this.nextCursor != 'no_more' && this.nextCursor) {
        data.cursor = this.nextCursor
      } else {
        data.cursor = ''
      }
      this.fullscreenLoading = true
      const res = await videoAnalyze(data)
      this.fullscreenLoading = false
      if (res.code == 10000) {
        if (this.nextCursor != 'no_more' && this.nextCursor && this.activeName == '2') {
          this.mulList.push(...res.data.data.posts)
          this.hasMore = res.data.data.has_more
          this.nextCursor = res.data.data.next_cursor
          this.chooseAll = false
        } else {
          if (this.activeName == '1') {
            this.mulList.push(res.data.data)
            this.hasMore = false
          } else {
            this.mulList = res.data.data.posts
            this.hasMore = res.data.data.has_more
            this.nextCursor = res.data.data.next_cursor
          }
        }
      }
    },
  }
}
</script>

<style lang="less" scoped>
.analyze-container {
  width: 1200px;
  margin: 30px auto 30px;
  padding-left: 20px;
  box-sizing: border-box;
  .title {
    font-size: 24px;
    font-weight: bold;
    margin-left: 24px;
  }
  .intro-code-box {
    display: flex;
    margin-top: 20px;
    .intro {
      width: 750px;
      padding: 15px 20px;
      background: #eeeeee;
      border-radius: 5px;
      font-size: 14px;
    }
    .code {
      margin-left: 82px;
      img {
        width: 130px;
        height: 130px;
      }
    }
  }
  .tab-box {
    width: 790px;
    margin-top: 40px;
    font-size: 14px;
    /deep/ .el-tabs__item {
      font-size: 20px;
      font-weight: 600;
    }
    /deep/ .el-tabs__active-bar {
      height: 4px;
    }
    /deep/ .el-tabs__nav-wrap::after {
      height: 4px;
    }
    /deep/ .el-tabs__nav {
      padding-bottom: 10px;
    }
  }
  .use-method {
    background: #eeeeee;
    border-radius: 5px;
    padding: 10px 19px;
    margin-top: 14px;
    width: 750px;
    &-title {
      font-size: 20px;
      font-weight: 600;
    }
    &-content {
      font-size: 14px;
      a {
        color: #3898ff;
      }
    }
  }
  .input-box {
    width: 500px;
    display: flex;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #3898ff;
    margin-top: 40px;
    input {
      flex: 1;
      border-radius: 12px 0 0 12px;
      padding-left: 20px;
      font-size: 16px;
      border: none;
    }
    .btn {
      padding: 13px 32px;
      background: #3898ff;
      color: #ffffff;
      border-radius: 0px 12px 12px 0px;
      cursor: pointer;
    }
  }
  .mul-video-box {
    padding-top: 30px;
    &-top {
      display: flex;
      align-items: center;
      .choose-all {
        display: flex;
        align-items: center;
        font-size: 20px;
        font-weight: 600;
        margin-right: 60px;
        cursor: pointer;
        img {
          width: 34px;
          height: 34px;
          margin-right: 10px;
        }
      }
      .download {
        display: flex;
        align-items: center;
        font-size: 20px;
        font-weight: 600;
        color: #3898ff;
        cursor: pointer;
        img {
          width: 31px;
          height: 29px;
          margin-right: 10px;
        }
      }
    }
    &-bot {
      display: flex;
      flex-wrap: wrap;
      margin-top: 25px;
      &-item {
        .media-content {
          width: 200px;
          height: 285px;
          display: inline-block;
          margin-right: 18px;
          margin-bottom: 18px;
          &-top {
            width: 200px;
            height: 200px;
            box-sizing: border-box;
            position: relative;
            background: #000;
            .cover {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .choose {
              width: 30px;
              height: 30px;
              position: absolute;
              right: 8px;
              bottom: 8px;
              cursor: pointer;
            }
          }
          &-bot {
            .post-name {
              font-size: 12px;
              margin-top: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              font-weight: 600;
            }
            .btn-box {
              display: flex;
              align-items: center;
              justify-content: space-evenly;
              .download {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 10px;
                font-size: 14px;
                color: #3898ff;
                font-weight: 600;
                text-align: center;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
    .view-more {
      width: 168px;
      padding: 12px 0;
      text-align: center;
      font-size: 14px;
      color: #666666;
      border-radius: 10px;
      border: 1px solid #979797;
      margin: 0 auto;
      cursor: pointer;
    }
  }
  .question-box {
    width: 790px;
    &-title {
      display: flex;
      align-items: center;
      span {
        font-size: 46px;
        color: #3898ff;
        font-weight: 600;
      }
      .question-title {
        font-size: 20px;
        font-weight: 600;
        margin-left: 5px;
      }
      .line {
        flex: 1;
        height: 4px;
        background: #EEEEEE;
        margin-left: 20px;
      }
    }
    &-item {
      &-top {
        margin-top: 30px;
        font-weight: 600;
        font-size: 16px;
      }
      &-bot {
        margin-top: 20px;
        font-size: 14px;
      }
    }
  }
}
</style>